<template>
  <div class="Condiciones">
    <Header
      style="background: linear-gradient(307deg, #f98043 0%, #c90000 100%);"
    />
    <div class="content">
      <h1>Términos y condiciones de uso</h1>
      <div class="privacidad">
        <p>1. ACEPTACIÓN Y ALCANCE DE LOS TÉRMINOS Y CONDICIONES</p>
        <p>
          Estos términos y condiciones de uso, en adelante “Términos”, son
          aplicables para el uso de los servicios ofrecidos por CrediSol a través de la aplicación para
          teléfonos móviles, en adelante “Aplicación”. El usuario manifiesta y
          declara expresamente que acepta todos los Términos establecidos en el
          presente documento con la instalación y uso de la Aplicación. La
          instalación y uso de la Aplicación se entenderá como plena e indudable
          manifestación de la voluntad y su aceptación con los presentes
          Términos. Si usted no está de acuerdo con los Términos de uso de la
          Aplicación y las políticas de privacidad de CrediSol, no instale la
          aplicación y/o no realice uso de ella.
        </p>
        <p>2. DEFINICIONES</p>
        <p>(i) “Usuario”: Todo aquel que utilice la Aplicación de CrediSol</p>
        <p>
          (ii) “Préstamo”: Servicio crediticio solicitado por el Usuario y
          otorgado por CrediSol a cambio de una retribución monetaria indicada y
          aceptada previo a la solicitud del usuario, bajo las condiciones del
          Contrato de Mutuo Dinerario que se encuentra en el Anexo 1.
        </p>
        <p>
          (iii) “Teléfono móvil”: Dispositivo utilizado por el Usuario para
          instalar la Aplicación de CrediSol.
        </p>
        <p>
          (iv) “Algoritmo crediticio”: Software y procedimientos de propiedad de
          CrediSol para tomar decisiones de los servicios financieros brindados.
        </p>
        <p>3. ¿QUE ES CrediSol?</p>
        <p>
          CrediSol es una aplicación que permite al Usuario solicitar préstamos
          monetarios. Estos préstamos pueden ser otorgados o no por CrediSol de
          acuerdo al algoritmo crediticio utilizado por CrediSol.
        </p>
        <p>4. REGISTRO Y USO DE LA APLICACIÓN</p>
        <p>
          a) Al realizar el registro, el Usuario acepta proveer información
          exacta, completa y actualizada que se requiera para completar el
          proceso de registro, pudiendo CrediSol realizar controles que crea
          convenientes para verificar la veracidad de la misma.
        </p>
        <p>
          b) Al realizar el registro, el Usuario autoriza a que la Aplicación
          comparta información de uso y comportamiento crediticio con los
          contactos que el usuario tiene guardados en su dispositivo que también
          utilizan la aplicación.
        </p>
        <p>
          c) Solo las personas que tienen la capacidad legal de ejercicio están
          autorizados a utilizar la aplicación. Las personas que no cuenten con
          esta capacidad, entre ellos los menores de edad, deben desistir del
          uso de la Aplicación. En este sentido, la declaración realizada por el
          Usuario al momento de ingresar sus datos en la Aplicación se entenderá
          como una declaración jurada.
        </p>
        <p>
          d) CrediSol no se responsabiliza por cualquier daño como resultado de
          la pérdida o mal uso de la clave por parte de terceros. El Usuario es
          el único responsable por ello.
        </p>
        <p>
          e) El registro de Usuario es personal y no se puede transferir por
          ningún motivo a terceras personas.
        </p>
        <p>
          f) El incumplimiento de alguno de los puntos señalados puede devenir
          en suspensión temporal o definitiva de las cuentas de los Usuarios en
          cualquier momento. El incumplimiento de las políticas internas podrá
          devenir en similares determinaciones.
        </p>
        <p>5. LIMITACIONES DE LA RESPONSABILIDAD</p>
        <p>
          a) El Usuario declara conocer expresamente que la Aplicación requiere
          de permisos especiales para funcionar en el Teléfono móvil, y que
          CrediSol no será responsable por los efectos que pudiera generar la
          revocación y/o intento de revocación de aquellos permisos especiales.
          Los usuarios renuncian desde ya al derecho de imponer cualquier
          reclamo al respecto.
        </p>
        <p>
          b) Dado que la Aplicación se encuentra en un proceso de mejora
          continua y constante actualización CrediSol no puede garantizar que la
          misma esté disponible sin interrupciones y que siempre esté libre de
          errores, y por tanto, no se responsabiliza por posibles perjuicios
          causados al Usuario por este concepto.
        </p>
        <p>
          c) Dado que cada solicitud de Préstamo es evaluada de forma
          independiente y su aceptación está sujeta tanto al resultado del
          Algoritmo crediticio como a la disponibilidad de fondos de CrediSol,
          el Usuario reconoce que la solicitud de Préstamo no es vinculante al
          posible servicio de Préstamo bajo ningún supuesto.
        </p>
        <p>6. OBLIGACIONES Y RESPONSABILIDADES DE LOS USUARIOS</p>
        <p>
          a) El Usuario certifica y declara que está usando la Aplicación por su
          propia voluntad, este reconoce y acepta las responsabilidades y
          riesgos por usar la Aplicación.
        </p>
        <p>
          b) El Usuario es responsable del consumo de datos o internet del
          dispositivo en el cual ejecuta/utiliza la Aplicación. En tal sentido,
          declara consentir que la Aplicación utilizará y/o consumirá recursos
          de su plan de datos y/o internet contratado con su operador de
          telefonía según el uso que hagan de ella.
        </p>
        <p>
          c) El Usuario que solicite un Préstamo y este sea aprobado se obliga a
          cumplir con las condiciones indicadas en el Anexo 1: Contrato de Mutuo
          Dinerario.
        </p>
        <p>7. PROCEDIMIENTO DE ATENCIÓN Y RECLAMOS</p>
        <p>
          Para la atención de cualquier reclamo con respecto a los servicios
          prestados por CrediSol, los Usuarios podrán presentar su reclamo por
          cualquiera de las vías que la normativa de protección al consumidor ha
          establecido, las cuales incluyen pero no se limitan a la presentación
          de un reclamo escrito vía correo electrónico a
          <span style="color: #0000ff">servicio@credisol.pe</span>.
        </p>
        <p>8. POLÍTICA DE PRIVACIDAD Y PROTECCIÓN DE DATOS PERSONALES</p>
        <p>
          De conformidad con la Ley N° 29733, Ley de Protección de Datos
          Personales y su norma reglamentaria D.S. y N° 003-2013-JUS y demás
          normas aplicables (en adelante, “la Ley”), en los términos vigentes de
          ambas, desde el momento que el Usuario haya declarado la aceptación
          expresa del tratamiento de sus datos personales mediante la
          realización de cliqueo/pinchado (u otro mecanismo utilizado) dispuesto
          para la autorización mencionada, CrediSol garantiza la seguridad y
          confidencialidad en el tratamiento de los datos de carácter personal
          facilitados por los Usuarios de conformidad con lo dispuesto en la
          Ley.
        </p>
        <p>
          Toda información entregada a CrediSol mediante la Aplicación y/o otro
          medio que utilice el Usuario será objeto de tratamiento automatizado e
          incorporada en una o más bases de datos de las que CrediSol es titular
          y responsable, conforme a los términos previstos por la Ley.
        </p>
        <p>
          El Usuario otorga autorización expresa e inequívoca a CrediSol para
          realizar tratamiento y hacer uso de la información personal que éste
          proporcione a CrediSol cuando acceda a la Aplicación y/o cualesquiera
          forma de registro que se utilice, participe en promociones
          comerciales, envíe consultas o comunique incidencias, y en general
          cualquier interacción en la Aplicación, además de la información que
          se derive del uso de productos y/o servicios que pudiera tener
          contratados con CrediSol y de cualquier información pública o que
          pudiera recoger a través de fuentes de acceso público, incluyendo
          aquellos a los que CrediSol tenga acceso como consecuencia de su
          navegación por la Aplicación o por su instalación en el Teléfono móvil
          (en adelante, la “Información”) para las finalidades de envío de
          comunicaciones comerciales, comercialización de productos y servicios,
          y del mantenimiento de su relación contractual con CrediSol. El
          Usuario otorga autorización expresa e inequívoca a CrediSol para
          enviar y almacenar sus datos a proveedores de almacenamiento de datos
          en el extranjero. La navegación en la Aplicación, la participación en
          promociones comerciales, y cualquier otra interacción implica el
          consentimiento expreso e inequívoco del Usuario para la cesión de sus
          datos personales a CrediSol. El Usuario reconoce y acepta que CrediSol
          podrá ceder sus datos personales a cualquier tercero, siempre que sea
          necesaria su participación para cumplir con la prestación de servicios
          y comercialización de productos y servicios.
        </p>
        <p>
          CrediSol podrá ceder, en su caso, la información a sus empresas
          subsidiarias, filiales, asociadas, afiliadas o miembros del grupo
          económico al cual pertenece y/o terceros con los que éstas mantengan
          una relación contractual, supuesto en el cual sus datos serán
          almacenados en los sistemas informáticos de cualquiera de ellos. En
          todo caso, CrediSol garantiza el mantenimiento de la confidencialidad
          y el tratamiento seguro de la Información en estos casos. El uso de la
          información por las empresas antes indicadas se circunscribe a los
          fines contenidos en el presente documento.
        </p>
        <p>
          La política de privacidad de CrediSol le asegura al usuario el
          ejercicio de los derechos de información, acceso, actualización,
          inclusión, rectificación, supresión o cancelación, oposición y
          revocación del consentimiento, en los términos establecidos en la Ley.
          En cualquier momento, el Usuario tendrá el derecho a solicitar a
          CrediSol el ejercicio de los derechos que le confiere la Ley, así como
          la revocación de su consentimiento según lo previsto en la Ley.
        </p>
        <p>
          CrediSol garantiza la confidencialidad en el tratamiento de los datos
          de carácter personal, así como haber adoptado los niveles de seguridad
          de protección de los datos personales, instalado en todos los medios y
          adoptando todas las medidas técnicas, organizativas y legales a su
          alcance que garanticen la seguridad y eviten la alteración, pérdida,
          tratamiento o acceso no autorizado a los datos personales.
        </p>
        <p>
          Para cualquier consulta sobre los alcances de la Política sobre
          Protección de Datos Personales o en caso los usuarios deseen ejercitar
          los derechos de acceso, actualización, inclusión, rectificación,
          supresión o cancelación, oposición u otros contemplados en la Ley,
          sobre sus datos personales, podrán enviar un correo electrónico a:
          <span style="color: #0000ff">servicio@credisol.pe</span>.
        </p>
        <p>9. SANCIONES</p>
        <p>
          CrediSol podrá notificar, suspender o cancelar, temporal o
          permanentemente, la cuenta de cualquier Usuario en cualquier momento,
          y tomar acciones legales si: (i) viola cualquiera de las
          representaciones, garantías y obligaciones contenidas en estos
          Términos o cualquier política o regla adyacente a la misma, (ii)
          realiza prácticas engañosas o fraudulentas, o (iii) si CrediSol
          concluye el Usuario no cumplira con el pago de cuotas de algún
          Préstamo aprobado. El Usuario no tendrá derecho a ninguna
          indemnización o compensación por la suspensión temporal o definitiva
          de su cuenta en la Aplicación.
        </p>
        <p>10. LICENCIA</p>
        <p>
          a) CrediSol brinda a los Usuarios una licencia limitada, personal, no
          exclusiva, intransferible, no comercial y totalmente revocable para
          utilizar la Aplicación, en conformidad y por acuerdo de los Términos
          contenidos en este documento. CrediSol se reserva todos los derechos
          sobre la Aplicación no expresamente concedidos aquí.
        </p>
        <p>
          b) CrediSol no se hace responsable de ningún daño sufrido por el
          usuario que realiza una copia, transferencia, distribución o uso de
          cualquier contenido de la Aplicación protegida, violando los derechos
          de los demás.
        </p>
        <p>11. CONDICIONES GENERALES</p>
        <p>
          a) Los Términos no generan ninguna sociedad, franquicia o relación
          laboral entre los Usuarios y CrediSol.
        </p>
        <p>
          b) Los Términos pueden ser cambiados por CrediSol en cualquier momento
          y sin previo aviso. Los cambios serán obligatorios automáticamente en
          la fecha de publicación de la nueva versión en la página web:
          https://www.credisol.pe/Uso Los presentes Términos se regirán e
          interpretarán de conformidad con la legislación Peruana y cualquier
          disputa y/o controversia entre los Usuarios y CrediSol y que no pueda
          ser resuelta de forma directa y/o a través de los mecanismos de
          conciliación legales, será sometida a la jurisdicción de los Jueces y
          Tribunales de Lima.
        </p>
        <p>
          d) Al registrarse en la Aplicación y aceptar los Términos, haciendo
          clic y/o tap en la opción “Acepto los términos de uso”, el Usuario
          declara automáticamente conocer y se compromete a cumplir con estos
          Términos y todas las demás políticas y normas disponibles en el
          sistema.
        </p>
        <p>
          e) Los cambios en los presentes Términos podrán ser comunicados
          mediante la Aplicación así como por medio del correo electrónico
          provisto por los Usuarios.
        </p>
        <p>12. COSTOS POR SERVICIOS ASOCIADOS</p>
        <p>
          El Usuario entiende y acepta que pueden existir otros costos asociados
          al servicio de Préstamo brindado por CrediSol, los cuales incluyen, y
          no se limitan a, costo de transferencia de fondos según la entidad
          financiera elegida para recibir los fondos del Préstamo solicitado, y
          costos de recaudación según la entidad financiera elegida para pagar
          las cuotas.
        </p>
        <p>
          CrediSol hará el mayor esfuerzo para reducir estos costos, siendo que
          ellos dependen de las condiciones comerciales que las entidades
          financieras externas cobran por sus servicios de forma independiente.
          CrediSol notificará oportunamente al usuario sobre estos costos
          asociados.
        </p>
        <p>13. DERECHOS DE PROPIEDAD INTELECTUAL</p>
        <p>
          CrediSol es titular de la propiedad intelectual de la Aplicación, los
          cuales incluyen de manera enunciativa y no limitativa: (i) el código
          fuente; (ii) el código objeto; (iii) marcas; (iv) nombres comerciales;
          (v) diseños; (vi) imágenes; (vii) vídeos; (viii) fotografías; (ix)
          lemas o slogans; y (x) finalmente cualquier creación que sea producto
          de la originalidad y se encuentra protegida por la Decisión 486 de la
          Comunidad Andina, el Decreto Legislativo 1075, la Decisión 351 de la
          Comunidad Andina, el Decreto legislativo 822 y demás Tratados
          internacionales y normativa aplicable. Por medio de los presentes
          Términos, la descarga o uso de la Aplicación CrediSol no transfiere
          ningún derecho de propiedad intelectual a los Usuarios.
        </p>
        <p class="title">ANEXO 1: CONTRATO DE MUTUO DINERARIO</p>
        <p>
          En caso un Usuario solicita un Préstamo y este es aprobado, se
          configura el presente Contrato de Mutuo Dinerario, que celebran, de
          una parte:<br />
          El Usuario cuyo nombre, documento de identificación, y domicilio ha
          sido declarado en la aplicación CrediSol, participa por derecho propio
          denominándosele en los sucesivo como EL MUTUATARIO, y de la otra
          parte;<br />
          CrediSol, a quien en lo sucesivo se denominará EL MUTUANTE;<br />
          El presente contrato se celebra bajo los términos y condiciones
          señalados en las siguientes cláusulas:
        </p>

        <p class="title">PRIMERA: ANTECEDENTES</p>
        <p>
          EL MUTUATARIO es una persona natural que ha solicitado a EL MUTUANTE
          un préstamo de dinero a ser devuelto con intereses compensatorios de
          acuerdo a lo estipulado en este contrato.<br />
          Tomando en cuenta lo solicitado por EL MUTUATARIO, por medio del
          presente documento EL MUTUANTE, manifiesta su interés en otorgar el
          préstamo dinerario que requiere EL MUTUATARIO cuyas condiciones serán
          estipuladas en las cláusulas siguientes.
        </p>

        <p class="title">SEGUNDA: OBJETO</p>
        <p>
          2.1. Por el presente Contrato EL MUTUANTE entrega, en calidad de
          MUTUO, a favor de EL MUTUATARIO, la suma de dinero acordado en la
          Aplicación de CrediSol; con el objeto de financiar las actividades de
          EL MUTUATARIO.
        </p>
        <p>
          2.2 La suma materia de mutuo será depositada a la cuenta que EL
          MUTUATARIO indique en la Aplicaciónde CrediSol.
        </p>
        <p class="title">
          TERCERA: INTERES COMPENSATORIO, FORMA DE PAGO Y OBLIGACIONES DE EL
          MUTUATARIO
        </p>
        <p>
          14. El interés compensatorio será aquel aceptado por EL MUTUATARIO en
          la Aplicación de CrediSol, el cual podrá ser indicado en forma
          porcentual relativa o de forma absoluta como valor a pagar.
        </p>
        <p>
          3.2. El presente contrato tiene validez hasta que el préstamo
          dinerario haya sido pagado tanto su valor de capital principal como
          intereses, costos de servicios asociados, moras y/o penalidades.
        </p>
        <p>
          3.3. El pago del capital más los intereses, costos de servicios
          asociados, moras y/o penalidades. será realizado a través de abono en
          la cuenta indicada por la Aplicación de CrediSol.
        </p>
        <p>
          3.4. La falta de pago dará derecho a EL MUTUANTE a las acciones
          listadas a continuación, EL MUTUATARIO no tendrá derecho a ninguna
          indemnización o compensación alguna por las medidas tomadas por EL
          MUTUANTE
        </p>
        <p>
          3.4.1. Ejecutar distintas medidas en el Teléfono móvil de EL
          MUTUATARIO de acuerdo a los permisos otorgados, incluyendo y no
          limitados a: bloqueo de la pantalla del Teléfono móvil o
          inhabilitación de servicios normales.
        </p>
        <p>
          3.4.2. Denunciar a EL MUTUATARIO por los atrasos de pagos a centrales
          de riesgo.
        </p>
        <p>
          3.4.3. Dar inicio a las acciones judiciales con la finalidad de cobrar
          la suma adeudada quedando EL MUTUATARIO constituido en mora sin
          necesidad de requerimiento alguno.
        </p>
        <p>
          3.5. Las partes acuerdan que, en caso de incumplimiento en el pago del
          capital, Los interéses por costos de servicios asociados, moras y/o
          penalidades, la suma adeudada podrá generar intereses moratorios de
          manera adicional al interés compensatorio pactado hasta la cancelación
          total del MUTUO. Estos intereses moratorios serán indicados en la
          Aplicación de CrediSol.
        </p>
        <p>
          3.6. Las partes acuerdan que EL MUTUATARIO podrá devolver el monto
          dinerario otorgado en mutuo, más el interés pactado, antes de la fecha
          de vencimiento, lo cual no generará la obligación de pago de penalidad
          alguna.
        </p>

        <p class="title">CUARTA: RESOLUCIÓN</p>
        <p>
          EL MUTUANTE podrá resolver de pleno derecho el presente Contrato de
          Mutuo Dinerario en cualquier momento y exigir el pago inmediato del
          íntegro de la suma otorgada en préstamo a EL MUTUATARIO, con los
          respectivos intereses que se hubieran devengado hasta la fecha.
        </p>

        <p class="title">QUINTA: SUBSISTENCIA DE ESTIPULACIONES</p>
        <p>
          La invalidez, ineficacia o inexigibilidad de cualquier disposición de
          este contrato no perjudicará la validez, eficacia o exigibilidad de
          las demás disposiciones, las cuales permanecerán con plena vigencia y
          efecto. Las partes pondrán todo de su parte para alcanzar los
          objetivos de la disposición nula a través de una estipulación nueva
          legalmente válida.
        </p>
        <p class="title">SEXTA: LEY APLICABLE</p>
        <p>
          Las partes acuerdan que el presente Contrato será regido por la Ley
          peruana. Asimismo, todo aquello que no esté regulado en este Contrato,
          se regirá por las normas pertinentes del Código Civil.
        </p>
        <p class="title">SÉTIMA: SOLUCIÓN DE CONTROVERSIAS</p>
        <p>
          Las partes acuerdan que cualquier controversia, diferencia o
          reclamación que se produzca entre ellas relativa a la interpretación,
          ejecución, resolución, rescisión, eficacia, validez u otro asunto
          vinculado al presente contrato, o por cualquier otro motivo o
          circunstancia relacionada directa o indirectamente con éste y con los
          que por causa de este Contrato se susciten se someterán a la
          competencia de los jueces y tribunales del distrito judicial de Lima.
        </p>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "../../components/newHeader.vue";
import Footer from "../../components/newFooter.vue";

export default {
  name: "Uso",
  components: { Header, Footer },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
*::-webkit-scrollbar {
  display: none;
}
.Condiciones {
  width: 100%;
  .content {
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 50px;
    box-sizing: border-box;
    h1 {
      font-size: 52px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #fcc222;
      margin: 66px 0 40px 0;
    }
    .privacidad {
      p {
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        margin-bottom: 20px;
      }
      .title {
        font-weight: 600;
        font-size: 28px;
      }
    }
  }
}
</style>
